/**
 * "Groups" block of a profile's menus — rendered from two surfaces: the row kebab and the Groups
 * cell's own menu. One component, so the two cannot drift apart.
 *
 * Every checkbox click writes immediately (#9, full membership replacement) — no draft, no Save
 * button, and the menu stays open so several groups can be toggled in one visit. The caller owns
 * the mutation and closes the menu for "New group…".
 */

import type { GroupDTO } from '@lw/shared';
import { CheckboxList, MenuItem, MenuLabel } from '../../components';

export type ProfileGroupsMenuItemsProps = {
  groups: GroupDTO[];
  selected: number[];
  /** The `Groups` heading; on by default (the kebab needs it). */
  showLabel?: boolean;
  onChange: (groupIds: number[]) => void;
  onNewGroup: () => void;
};

export function ProfileGroupsMenuItems({
  groups,
  selected,
  showLabel = true,
  onChange,
  onNewGroup,
}: ProfileGroupsMenuItemsProps) {
  return (
    <>
      {showLabel ? <MenuLabel>Groups</MenuLabel> : null}
      <CheckboxList
        className="menu__checklist"
        options={groups.map((group) => ({ value: group.id, label: group.name }))}
        selected={selected}
        onChange={onChange}
        emptyLabel="No groups yet."
      />
      <MenuItem onClick={onNewGroup}>New group…</MenuItem>
    </>
  );
}

export default ProfileGroupsMenuItems;
